import { useEffect, useSyncExternalStore } from 'react';
import * as vault from '../vault/vault';

/**
 * The vault's state, as a React store.
 *
 * `useSyncExternalStore` rather than context: the vault is a module-level state
 * machine that exists whether or not React is mounted, and unlock strength must
 * never be stale during a render that decides whether to reveal a hint.
 */
export function useVaultState(): vault.VaultState {
  const state = useSyncExternalStore(vault.subscribe, vault.getState, vault.getState);

  useEffect(() => {
    void vault.load();
  }, []);

  return state;
}
